import { gql } from "@apollo/client";

export const GET_PROVINCIAS = gql`
query QProvincias {
    provincias
    {
        success,
        error,
        valorEsperado {
            idProvincia,
            idPais,
            descripcion
        }
    }
}`;

export const adaptProvincia = (provincia) => ({
  id: provincia.idProvincia,
  displayName: provincia.descripcion
});

export const adaptProvinciasArray = (provincias) =>
structuredClone(provincias)?.
map((provincia) => adaptProvincia(provincia));